export enum WorkOrderRowOrigin {

  Standard = 1,
  System = 2

}
